import React from 'react'
import classNames from 'classnames'
import { FieldProps } from 'formik'
import { FieldWrapper, ErrorHelp } from '.'

const icons = {
  0: 'angry',
  1: 'meh',
  2: 'smile-beam',
}

type ButtonSelectProps = FieldProps & {
  label: string
}

const Rating: React.FC<ButtonSelectProps> = ({
  field: { value, name },
  form: { setFieldValue, setFieldTouched, touched, errors },
}) => {
  const common = {
    value,
    setFieldValue,
    setFieldTouched,
  }

  return (
    <FieldWrapper
      label={intl.formatMessage({ id: 'call / describe / rating' })}
      horizontal={false}
    >
      <div className="field">
        <div className="control">
          <div className="call-show-describe-rating">
            <Button {...common} name={2} />
            <Button {...common} name={1} />
            <Button {...common} name={0} />
          </div>
        </div>

        <ErrorHelp touched={touched} errors={errors} name={name} />
      </div>
    </FieldWrapper>
  )
}

export default Rating

type ButtonProps = {
  name: number
  value: number | null
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  setFieldTouched: (
    field: string,
    isTouched?: boolean | undefined,
    shouldValidate?: boolean | undefined
  ) => void
}

const Button: React.FC<ButtonProps> = ({
  setFieldValue,
  name,
  value,
  setFieldTouched,
}) => {
  const selected = name === value

  return (
    <button
      className={classNames({ 'is-active': selected })}
      type="button"
      onClick={() => {
        setFieldValue('rating', selected ? null : name)
        setFieldTouched('rating')
      }}
    >
      <span
        className={classNames(
          { fal: !selected, far: selected },
          'fa-' + icons[name]
        )}
      />
    </button>
  )
}

type StaticRatingFieldProps = {
  value: number | null
}

export const StaticRatingField: React.FC<StaticRatingFieldProps> = ({
  value,
}) => {
  return (
    <FieldWrapper
      label={intl.formatMessage({ id: 'call / describe / rating' })}
      horizontal={false}
    >
      <div className="field">
        <p className="control">
          {value === null ? (
            '-'
          ) : (
            <span
              className={classNames(
                'call-show-describe-rating-static',
                'fal fa-' + icons[value]
              )}
            />
          )}
        </p>
      </div>
    </FieldWrapper>
  )
}
